import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsMonitoringAlertsClearState } from 'reducers/translations/monitoringAlerts/reducer'
import MonitoringAlertsList from './MonitoringAlertsList'
import MonitoringAlertsItem from './MonitoringAlertsItem'

function MonitoringAlerts(props) {
  const {
    translationsMonitoringAlertsClearState,
    match: {
      params: { id },
    },
  } = props
  const MonitoringAlertsContent = id
    ? MonitoringAlertsItem
    : MonitoringAlertsList

  useEffect(
    () => () => {
      translationsMonitoringAlertsClearState()
    },
    [],
  )

  return (
    <div className="content">
      <MonitoringAlertsContent {...props} />
    </div>
  )
}

MonitoringAlerts.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsMonitoringAlertsClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsMonitoringAlertsClearState,
})(MonitoringAlerts)
